"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAppLayoutBodySection = exports.StyledAppLayoutHeaderSection = exports.StyledAppLayout = exports.StyledAppLayoutSection = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../helpers");
const styles_1 = require("../../helpers/styles");
const constants_1 = require("./helpers/constants");
exports.StyledAppLayoutSection = styled_components_1.default.div `
    display: flex;
    position: relative;
    flex-direction: column;
    flex-shrink: 0;
    min-width: ${({ minWidth }) => minWidth && (0, styles_1.getCSSSizeValue)(minWidth, constants_1.APP_LAYOUT_DEFAULT_MIN_WIDTH)};
`;
exports.StyledAppLayout = styled_components_1.default.div `
    display: flex;
    position: relative;
    flex-direction: column;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    min-width: 0;
    min-height: 0;
    flex-shrink: 0;
    overflow-x: auto;
    overflow-y: hidden;
    justify-content: stretch;
`;
exports.StyledAppLayoutHeaderSection = (0, styled_components_1.default)(exports.StyledAppLayoutSection) `
    display: flex;
    position: relative;
    flex-direction: column;
    flex-shrink: 0;
    height: ${helpers_1.SIZE_XXL};
    align-items: stretch;
`;
exports.StyledAppLayoutBodySection = (0, styled_components_1.default)(exports.StyledAppLayoutSection) `
    display: flex;
    position: relative;
    flex-direction: column;
    flex-shrink: 0;
    flex-grow: 1;
    height: ${({ hasHeader }) => hasHeader ? `calc(100% - ${helpers_1.SIZE_XXL})` : '100%'};
`;
//# sourceMappingURL=AppLayout.styles.js.map